import { Moment } from 'moment'

export const SHOW_ALL_BUDGET = 'ALL'

export function generatePriceFilterOptions(checkInDate: Moment | undefined, checkOutDate: Moment | undefined, budget: App.BusinessTraveller.BusinessBudget | undefined) {
  const totalNights = checkOutDate?.diff(checkInDate ?? checkOutDate, 'days') ?? 0
  const totalBudget = (budget?.budget ?? 0) * Math.max(totalNights, 0)
  const tenOverBudget = Math.round(totalBudget * 1.1)
  const twentyOverBudget = Math.round(totalBudget * 1.2)

  return [
    {
      label: 'Within budget',
      value: totalBudget.toString(),
    },
    {
      label: 'Up to 10% above budget',
      value: tenOverBudget.toString(),
    },
    {
      label: 'Up to 20% above budget',
      value: twentyOverBudget.toString(),
    },
    {
      label: 'Show all',
      value: SHOW_ALL_BUDGET,
    },
  ]
}
